module.exports = __webpack_public_path__ + "img/voucher_iron_weekend.b89717aa.jpg";